import { Modal } from "react-bootstrap";

const toTitleCase = (text = "") => text.replace(/\b\w/g, (char) => char.toUpperCase());

/**
 * Shared delete confirmation used for both single (row action) and bulk deletes.
 * Based on the Lab Technicians delete dialog.
 *
 * singular / plural: lowercase entity names, e.g. "lab technician" / "lab technicians".
 * count: number of records being deleted (1 for a single row delete).
 * Optional overrides: title, message (replaces the default question),
 * confirmLabel, and children (extra content shown under the message).
 */
const DeleteConfirmModal = ({
  show,
  count = 1,
  singular,
  plural,
  onConfirm,
  onCancel,
  loading = false,
  title,
  message,
  confirmLabel = "Delete",
  children,
}) => {
  const safeCount = count > 0 ? count : 1;
  const label = safeCount > 1 ? plural || `${singular}s` : singular;

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || `Delete ${toTitleCase(label)}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || (
          <p>
            This action can not be reversed. Are you sure you want to delete{" "}
            <strong>{safeCount}</strong> {label}?
          </p>
        )}
        {children}
        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-outline-secondary" onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={loading}>
            {confirmLabel}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteConfirmModal;
